import {FC} from "react";
import {Color, getCssVar} from "@web-libs/features/colors/application/colors";
import {SvgFunction, SvgProps} from "@web-libs/ui/svgs/types";
import {createHOC} from "@web-libs/util/hocs/create-hoc";

export type WithColorProps<P> = Omit<P, "fill"> & {color?:Color}
export type WithColorSvgFunction = FC<WithColorProps<SvgProps>>

function _withColor<P extends SvgProps>(WrappedComponent:FC<P>) {
    // eslint-disable-next-line react/display-name
    return (props:WithColorProps<P>) => {
        const {color, ...rest} = props;
        const _color: Color = color ? color : 'textColor';
        const cssVar = getCssVar(_color)
        return <WrappedComponent {...rest as P} fill={cssVar}/>
    }
}

export const withColor = createHOC("WithColor", _withColor)
